import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import LearnMoreDialog, {
  LearnMoreDialogCallbackInput,
  LearnMoreDialogUniqueProps,
} from '../LearnMoreDialog';

const { useDialogForContext, useDialog: useLearnMoreDialog } = getDialogHooks<
  LearnMoreDialogUniqueProps,
  LearnMoreDialogCallbackInput
>(LearnMoreDialog);
export const useLearnMoreDialogForContext = useDialogForContext;
export default useLearnMoreDialog;
